'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoCalendar = function GoCalendar(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 20h-2.5v5h2.5v-5z m-5 0h-2.5v5h2.5v-5z m5-7.5h-2.5v5h2.5v-5z m5 7.5h-2.5v5h2.5v-5z m-10 7.5h-2.5v5h2.5v-5z m7.5-27.5h-2.5v5h2.5v-5z m-20 0h-2.5v5h2.5v-5z m22.5 12.5h-2.5v5h2.5v-5z m-10 0h-2.5v5h2.5v-5z m-10 15h-2.5v5h2.5v-5z m-5-7.5h-2.5v5h2.5v-5z m5 0h-2.5v5h2.5v-5z m20-17.5v5h-7.5v-5h-12.5v5h-7.5v-5h-5v35h37.5v-35h-5z m2.5 32.5h-32.5v-25h32.5v25z m-27.5-7.5h-2.5v5h2.5v-5z m10-15h-2.5v5h2.5v-5z m0 15h-2.5v5h2.5v-5z m-5-15h-2.5v5h2.5v-5z m5 7.5h-2.5v5h2.5v-5z m10 7.5h-2.5v5h2.5v-5z' })
        )
    );
};

exports.default = GoCalendar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/calendar.js
// module id = 1875
// module chunks = 0